'use client';

import { useLayoutEffect, useState } from 'react';

type UseFocusInputCursorHookProps = {
    inputRef: React.RefObject<HTMLInputElement | null>;
    shouldRefocus: boolean;
};

export const useFocusInputCursor = ({ inputRef, shouldRefocus }: UseFocusInputCursorHookProps) => {
    const [cursorPosition, setCursorPosition] = useState<number | null>(null);

    useLayoutEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current.setSelectionRange(
                inputRef.current.value.length,
                inputRef.current.value.length,
            );
        }
    }, [inputRef, shouldRefocus]);

    useLayoutEffect(() => {
        if (inputRef.current && cursorPosition !== null) {
            inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
    }, [inputRef, cursorPosition]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCursorPosition(event.target.selectionStart);
    };

    return { handleInputChange };
};
